import { data } from '../../svg/ArrowCircleLeft/data';
import { makeIcon } from '../makeIcon';

export const ArrowCircleLeft = makeIcon(data, 'arrow_circle_left', 'ArrowCircleLeft');

export default ArrowCircleLeft;
